document.addEventListener('DOMContentLoaded', function() {
    const fpoElements = document.querySelectorAll('.ctn_product_column .ctn_products .ctn_img .fpo');
    
    fpoElements.forEach(function(fpo) {
        adjustFontSize(fpo);
        
        const observer = new MutationObserver(function(mutations) {
            adjustFontSize(fpo);
        });
        
        observer.observe(fpo, {
            childList: true,
            characterData: true,
            subtree: true
        });
    });

    window.addEventListener('resize', function() {
        fpoElements.forEach(function(fpo) {
            adjustFontSize(fpo);
        });
    });

    function adjustFontSize(element) {
        const textLength = element.textContent.trim().length;
        
        const section = element.closest('.section_product_column');
        const computedStyle = getComputedStyle(section);
        const fpoValue = computedStyle.getPropertyValue('--font-size-fpo').trim();
        
        let baseFontSize;
        if (fpoValue.includes('vw')) {
            const vwValue = parseFloat(fpoValue);
            baseFontSize = (vwValue * window.innerWidth) / 100;
        } else {
            baseFontSize = parseFloat(fpoValue) || 129;
        }
        
        const minFontSize = 30;
        
        let fontSize = baseFontSize;
        
        if (textLength <= 3) {
            fontSize = baseFontSize;
        } else if (textLength <= 10) {
            fontSize = baseFontSize * 0.8;
        } else if (textLength <= 20) {
            fontSize = baseFontSize * 0.6;
        } else if (textLength <= 30) {
            fontSize = baseFontSize * 0.5;
        } else if (textLength <= 50) {
            fontSize = baseFontSize * 0.4;
        } else {
            fontSize = baseFontSize * 0.3;
        }
        
        fontSize = Math.max(fontSize, minFontSize);
        element.style.setProperty('font-size', fontSize + 'px', 'important');
    }
});
